import React from "react";
import NavItem from "./widgets/Nav/Loadable";
import {
    BackTick,
    ContactUseHeaderBox,
    HeaderDiv,
    MenuAnchor,
    ContactUseDetailsBox,
    LoggedSignInWrapper,
    ContactUsHeadPhoneIcn,
    ContactUsCallIcon,
    ContactUsMobileHeaderBox,
    ContactUseDetailsMobBox,
    ContactUsMobileHeaderWrapper,
    // VirtualWebinarDiv,
} from "./widgets/HeaderStyled";
import {MenuLoader} from "./widgets/loaderStyled";
import Sticky from "../Sticky/Loadable";
import config from "../../config/config";
import {deleteSignUpCookies} from "../../utils/utils";
import {truncateString} from "../../utils/string";
import PropTypes from "prop-types";
import {getImageUrlBySize, prependDomainToImageUrl} from "../../utils/image";
import {connect} from "react-redux";
import {setHeaderExpandedShrinkStatus, fetchGNB, setAversionLayerHandler} from "../Layout/actions";
import OutsideAlerter from "../../hoc/OutsideAlerter";
import {validateField} from "../../utils/validation";
import {DashboardTag} from "../RightDrawer/widgets/Styled";
import {STATUS_FIXED, STATUS_RELEASED} from "../Sticky/utils";
import {HeaderNavItemLoader} from "./widgets/HeaderNavLoader";
import {setTrackingDataAction} from "../../containers/RegistrationLoginPage/actions";
import {REGISTRATION_LOGIN} from "../../types/index";
import {addReferralTitleAndUrl} from "../CTA/response";
import LossAversionLayer from "../Registration/widgets/LossAversionLayer/widget/Loadable";
import Anchor from "../HTMLEntities/Anchor";
import GDPR from "../GDPR";
import {setCookie} from "../../utils/utils";

//https://stackoverflow.com/questions/48060660/how-to-stop-onmouseout-event-after-onclick-event-reactjs
class Header extends React.PureComponent {
    constructor(props) {
        super(props);
        const {hideGNBMenu} = props;
        let isLoading = false;
        this.aversionLayerURL = null;
        if (!hideGNBMenu) {
            isLoading = !props.gnbData;
        }
        this.state = {
            headerClass: "navHeight",
            navHoverActiveIndex: false,
            navClickActiveIndex: false,
            enableSticky: this.props.isSticky,
            isHamburgerOpen: false,
            headerCurrentlyStickyState: false,
            scrollStarted: false,
            linkedClick: false,
            isLoading: isLoading,
            showAversionLayer: false,
            headerReleased: false,
            isOpen: false,
            showStickyGDPRBanner: false,
            showInlineGDPRBanner: false,
            stopStickyGDPR: false,
        };
        this.lastScrollTop = -88;
        this.headerCurrentlySticky = false;
        this.stickyWrapperClass = "navExpanded";
        this.shortlistUrl = null;
        this.scrollStarted = false;
        this.hamburgerLoadCalled = false;
        this.closeGPDR = this.closeGPDR.bind(this);
    }

    static getDerivedStateFromProps(nextProps) {
        const {isSticky} = nextProps;
        if (isSticky === false) {
            return {
                headerClass: "navHeight",
                enableSticky: false,
                headerCurrentlyStickyState: false,
                headerReleased: false,
            };
        }
        return null;
    }

    gnbHeaderHeight = (node) => {
        const {setGNBHeight} = this.props;
        if (node !== null) {
            let height = node.getBoundingClientRect().height;
            setGNBHeight(height);
        }
    };

    componentDidMount() {
        const {
            hideGNBMenu,
            gnbData,
            fetchGNB,
            setHeaderExpandedShrinkStatus,
            setHeaderCurrentStickyStatus,
        } = this.props;
        setHeaderExpandedShrinkStatus("navHeight");
        setHeaderCurrentStickyStatus(false);
        Sticky.preload();
        if (!hideGNBMenu && !gnbData) {
            this.setState({isLoading: true});
            fetchGNB();
        } else {
            this.gnbHeaderHeight(document.getElementById("header"));
        }
        window.addEventListener("scroll", this.handleScroll);

        //menu tunneling
        // document.querySelectorAll(".g_lev2").forEach((currObj) => {
        //     console.log("header 1234");
        //     this.gnbTunneling(currObj, {
        //         activate: this.activateSubmenu.bind(this),
        //         deactivate: this.deactivateSubmenu.bind(this),
        //     });
        // });
    }

    // activateSubmenu(row) {
    //     console.log("GNB activate Submenu");
    //     document.querySelector(".menu-overlay-sa").style.display = "block";
    //     let submenu = document.querySelectorAll(".g_lev1 ul.g_lev2 > li");
    //     console.log("header submenu ---------------------", submenu);
    //     for (var i = 0; i < submenu.length; i++) {
    //submenu[i].classList.remove("activee");
    //     submenu[i].querySelector(".submenu2").style.display = "none";
    // }
    // if (
    //     document.querySelector(".nav-othercourses ul.g_lev2").style.top ==
    //     "-240px"
    // ) {
    //     document
    //         .querySelectorAll(".nav-othercourses ul.g_lev2 > li .submenu2")
    //         .forEach((currObj) => {
    //             currObj.style.top = "240px";
    //         });
    // } else {
    //     document
    //         .querySelectorAll(".nav-othercourses ul.g_lev2 > li .submenu2")
    //         .forEach((currObj) => {
    //             currObj.style.top = "-3px";
    //         });
    // }
    // row.classList.add("activee");
    // let submenu2 = row.querySelector("div.submenu2");
    // submenu2.style.display = "block";
    // this.setGNBHeight(row.parentElement.parentElement.parentElement);
    // console.log("aaa");
    // this.manageotherBoxHeight(submenu2);
    // }
    // deactivateSubmenu(row) {
    //     console.log("GNB deactivate Submen11u");
    //     let submenu2 = row.querySelector("div.submenu2");
    //     submenu2.style.display = "none";
    // row.classList.remove("activee");
    // }

    componentDidUpdate(prevProps) {
        const {
            isSticky: isPreviouslySticky,
            gnbData: prevData,
            hideGNBMenu: prevHideGNBMenu,
        } = prevProps;
        const {
            hideGNBMenu,
            isSticky,
            gnbData,
            setHeaderExpandedShrinkStatus,
            setHeaderCurrentStickyStatus,
            fetchGNB,
        } = this.props;
        const {isLoading} = this.state;

        if (!gnbData) {
            if (prevHideGNBMenu === true && hideGNBMenu === false) {
                this.setState({isLoading: true});
                fetchGNB();
            }
        }

        if (!prevData && gnbData) {
            if (isLoading) {
                this.setState({isLoading: false});
            }
            this.gnbHeaderHeight(document.getElementById("header"));
        }
        if (!isSticky && isSticky !== isPreviouslySticky) {
            setHeaderExpandedShrinkStatus("navHeight");
            setHeaderCurrentStickyStatus(false);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        const {scrollStarted} = this.state;
        const {gnbData} = this.props;
        if (!scrollStarted) {
            this.setState({scrollStarted: true});
        }
        if (validateField(gnbData, "object") && this.props.isSticky) {
            let subFactor = this.props.isMobile
                ? 47
                : this.stickyWrapperClass === "navExpanded"
                ? 88
                : 55;
            this.scrollStarted = true;
            let st = window.pageYOffset || document.documentElement.scrollTop;
            st = st - subFactor;
            if (this.props.isMobile) {
                this.handleMobileSticky(st);
            } else {
                this.handleDesktopSticky(st);
            }
            this.lastScrollTop = st;
        }
    };

    handleMobileSticky = (st) => {
        if (!this.props.isPageScrolling) {
            let mutableState = {...this.state};
            if (st > this.lastScrollTop) {
                mutableState.enableSticky = false;

                if (st > 200 && !this.state.stopStickyGDPR) {
                    mutableState.showInlineGDPRBanner = true;
                    mutableState.showStickyGDPRBanner = true;
                }
            } else {
                mutableState.enableSticky = true;
                mutableState.showStickyGDPRBanner = false;
            }

            if (st === 0 || st > window.innerHeight * 2) {
                mutableState.stopStickyGDPR = true;
            }

            if (
                this.state.enableSticky !== mutableState.enableSticky ||
                this.state.showStickyGDPRBanner !== mutableState.showStickyGDPRBanner ||
                this.state.showInlineGDPRBanner !== mutableState.showInlineGDPRBanner ||
                this.state.stopStickyGDPR !== mutableState.stopStickyGDPR
            ) {
                this.setState(mutableState);
            }
        }
    };

    handleDesktopSticky = (st) => {
        if (this.headerCurrentlySticky) {
            let mutableState = {...this.state};
            if (st > this.lastScrollTop) {
                let el = document.querySelector(".main-header .melabel.active");
                if (el == null) {
                    mutableState.headerClass = "navStickyHeight";
                    this.stickyWrapperClass = "navShrink";
                } else {
                    mutableState.headerClass = "navHeight";
                    this.stickyWrapperClass = "navExpanded";
                }
            } else {
                mutableState.headerClass = "navHeight";
                this.stickyWrapperClass = "navExpanded";
            }
            if (this.state.headerClass !== mutableState.headerClass) {
                this.props.setHeaderExpandedShrinkStatus(mutableState.headerClass);
                this.setState(mutableState);
            }
        }
    };

    handleStateChange = (status) => {
        const {isMobile, setHeaderCurrentStickyStatus} = this.props;
        this.headerCurrentlySticky = status.status === STATUS_FIXED;
        const headerReleased = status.status === STATUS_RELEASED;
        setHeaderCurrentStickyStatus(this.headerCurrentlySticky);
        let mutableState = {
            headerCurrentlyStickyState: this.headerCurrentlySticky,
            headerReleased: headerReleased,
        };
        if (
            this.state.headerCurrentlyStickyState !== mutableState.headerCurrentlyStickyState ||
            isMobile
        ) {
            this.setState(mutableState);
        }
    };

    navMenuClick = () => {
        this.navMenuHoverLeave();
        let mutableState = {...this.state};
        mutableState.linkedClick = true;
        mutableState.navHoverActiveIndex = false;
        this.setState(mutableState);
        this.closeHamburger();
    };
    navMenuHoverEnter = (index) => {
        // alert('en');
        if (this.props.isMobile && this.state.linkedClick === true) {
            return false;
        }
        if (!this.props.isMobile) {
            let mutableState = {...this.state};
            mutableState.navHoverActiveIndex = index;
            this.props.setNavHoverStatus(true);
            this.setState(mutableState);
        }
    };
    navMenuHoverLeave = () => {
        //   alert('le');
        if (!this.props.isMobile) {
            let mutableState = {...this.state};
            mutableState.navHoverActiveIndex = false;
            this.props.setNavHoverStatus(false);
            this.setState(mutableState);
        }
    };

    handleHamburgerMainSection = (index) => {
        if (this.props.isMobile) {
            let mutableState = {...this.state};
            if (mutableState.navClickActiveIndex === index) {
                mutableState.navClickActiveIndex = false;
            } else {
                mutableState.navClickActiveIndex = index;
            }

            this.setState(mutableState);
        }
    };

    openHamburger = () => {
        if (this.props.isMobile) {
            //var stickyInnerEle             = document.getElementsByClassName("sticky-outer-wrapper")[0].children[0];
            this.props.setNavHoverStatus(true);
            this.setState({isHamburgerOpen: true});
            document.body.classList.add("fixed-body");
        }
    };

    closeHamburger = () => {
        const {isHamburgerOpen} = this.state;
        if (isHamburgerOpen === false) {
            return;
        }

        if (this.props.isMobile) {
            document.body.classList.remove("fixed-body");
            this.props.setNavHoverStatus(false);

            let mutableState = {};
            mutableState.navClickActiveIndex = false;
            mutableState.isHamburgerOpen = false;
            this.setState(mutableState);
        }
    };

    userSectionDesktopHandling = () => {
        const {hideGNBLoginSignUp} = this.props;
        if (hideGNBLoginSignUp) return null;
        if (this.props.userLoggedIn) {
            return this.userSectionDesktopLoggedInState();
        } else {
            return this.userSectionDesktopNotLoggedInState();
        }
    };

    loadSignUpLogin = (trackingKey, type = "signUp") => {
        const {setTrackingDataAction, pageName, history} = this.props;
        deleteSignUpCookies();
        trackingKey &&
            setTrackingDataAction(
                {
                    trackingId: trackingKey,
                    ctaType: REGISTRATION_LOGIN,
                    ...addReferralTitleAndUrl(pageName ?? ""),
                },
                REGISTRATION_LOGIN,
            );
        let pageContextTrackingObj = {};
        if (typeof pageName !== "undefined" && pageName !== "") {
            pageContextTrackingObj["pageIdentifer"] = pageName;
            setCookie("pageContextTrackingObj", btoa(JSON.stringify(pageContextTrackingObj)));
        }
        if (type === "signUp") {
            history.push(`${config.SHIKSHA_STUDYABROAD_BASENAME}/signup`);
        } else {
            history.push(`${config.SHIKSHA_STUDYABROAD_BASENAME}/login`);
        }
    };
    toggleClass = () => {
        const currentState = this.state.isOpen;
        this.setState({isOpen: !currentState});
    };
    userSectionDesktopLoggedInState = () => {
        const {showNewTagInHeader, pageName} = this.props;
        const {isOpen} = this.state;
        const pageStr = pageName;
        this.firstName = truncateString(
            this.props.userData.firstName.split(" ").slice(0, 1).join(""),
            "9",
        );
        this.profilePicUrl = getImageUrlBySize(
            prependDomainToImageUrl(this.props.userData.avtarUrl),
            "small",
        );
        this.shortlistUrl = config.SHIKSHA_STUDYABROAD_HOME + this.props.shortListData.shorlistURL;

        const utm_Webmedium = this.props.isMobile ? "mweb" : "dweb";
        const needCounselingUrl = `/apply?utm_source=GNB&utm_medium=${utm_Webmedium}&utm_campaign=NL`;
        const arrowRotate = this.state.isOpen ? true : false;
        return (
            <div className="lggd-sgnDiv">
                <LoggedSignInWrapper>
                    {pageStr != "applyHomePage" && pageStr != "TopperPage" && (
                        <>
                            <ContactUseHeaderBox
                                onClick={this.toggleClass}
                                arrowRotate={arrowRotate}
                            >
                                Contact Us
                            </ContactUseHeaderBox>
                            {isOpen && (
                                <OutsideAlerter
                                    isMobile={this.props.isMobile}
                                    // isActive={isHamburgerOpen}
                                    componentHandler={() => this.toggleClass()}
                                    overlayCheck={false}
                                    isActive={isOpen}
                                >
                                    <ContactUseDetailsBox>
                                        <Anchor
                                            linkHref={needCounselingUrl}
                                            target={"_blank"}
                                            isPWALink={false}
                                            displayStyle={{
                                                mobile: {},
                                                laptop: {
                                                    fontWeight: "400",
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            <ContactUsHeadPhoneIcn />
                                            Get Free Counseling
                                        </Anchor>
                                        <Anchor
                                            linkHref={`tel:+91-8069474732`}
                                            displayStyle={{
                                                mobile: {},
                                                laptop: {
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            <ContactUsCallIcon />
                                            Call <strong>08069474732</strong>
                                        </Anchor>
                                    </ContactUseDetailsBox>
                                </OutsideAlerter>
                            )}
                        </>
                    )}
                    <a
                        className="user-hdr-icon"
                        href="#"
                        alt="User icon"
                        title="User-icon"
                        onClick={(e) => {
                            e.preventDefault();
                            this.props.handleRightDrawer(true);
                        }}
                    >
                        <img className="small-pp-img" src={this.profilePicUrl} />
                        {this.firstName}
                        {showNewTagInHeader && <DashboardTag newTag>NEW</DashboardTag>}
                    </a>
                </LoggedSignInWrapper>
            </div>
        );
    };

    userSectionDesktopNotLoggedInState = () => {
        const {headerSignUpTrackingKey, pageName} = this.props;
        const {isOpen} = this.state;
        const pageStr = pageName;
        let signUpTrackingKey = validateField(headerSignUpTrackingKey, "object", "laptop")
            ? headerSignUpTrackingKey.laptop
            : "";

        const utm_Webmedium = this.props.isMobile ? "mweb" : "dweb";
        const needCounselingUrl = `/apply?utm_source=GNB&utm_medium=${utm_Webmedium}&utm_campaign=NL`;
        const arrowRotate = this.state.isOpen ? true : false;
        return (
            <div className="lgn-sgnDiv needCounsling_Link">
                {/* {pageStr != "applyHomePage" && (
                    <Anchor
                        linkHref={needCounselingUrl}
                        linkLabel={"Need Counseling?"}
                        target={"_blank"}
                        isPWALink={true}
                        displayStyle={{
                            mobile: {},
                            laptop: {
                                fontWeight: "600",
                                fontSize: "0.75rem",
                            },
                        }}
                    />
                )} */}
                <LoggedSignInWrapper loggedOutDiv={true}>
                    {pageStr != "applyHomePage" && pageStr != "TopperPage" && (
                        <>
                            <ContactUseHeaderBox
                                onClick={this.toggleClass}
                                arrowRotate={arrowRotate}
                            >
                                Contact Us
                            </ContactUseHeaderBox>
                            {isOpen && (
                                <OutsideAlerter
                                    isMobile={this.props.isMobile}
                                    componentHandler={() => this.toggleClass()}
                                    overlayCheck={false}
                                    isActive={isOpen}
                                >
                                    <ContactUseDetailsBox loggedOutDiv={true}>
                                        <Anchor
                                            linkHref={needCounselingUrl}
                                            target={"_blank"}
                                            isPWALink={false}
                                            displayStyle={{
                                                mobile: {},
                                                laptop: {
                                                    fontWeight: "400",
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            <ContactUsHeadPhoneIcn />
                                            Get Free Counseling
                                        </Anchor>
                                        <Anchor
                                            linkHref={`tel:+91-8069474732`}
                                            displayStyle={{
                                                mobile: {},
                                                laptop: {
                                                    width: "100%",
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            <ContactUsCallIcon />
                                            Call <strong>08069474732</strong>
                                        </Anchor>
                                    </ContactUseDetailsBox>
                                </OutsideAlerter>
                            )}
                        </>
                    )}
                </LoggedSignInWrapper>
                <span className="a-loginSgnup">
                    <i className="blank-pp-icon icons" />
                    <a
                        href="#"
                        action="login"
                        alt="login"
                        title="Login"
                        onClick={(e) => {
                            e.preventDefault();
                            deleteSignUpCookies();
                            this.loadSignUpLogin(signUpTrackingKey, "login");
                        }}
                    >
                        Login
                    </a>
                    {/* <span className="registerPipe">|</span> */}
                    <a
                        href="#"
                        alt="signup"
                        title="Signup"
                        className="signupBtn"
                        onClick={(e) => {
                            e.preventDefault();
                            this.loadSignUpLogin(signUpTrackingKey, "signUp");
                        }}
                    >
                        Sign Up
                    </a>
                </span>
            </div>
        );
    };

    userSectionMobileHandling = () => {
        const {headerSignUpTrackingKey, userLoggedIn, handleRightDrawer} = this.props;
        if (userLoggedIn) {
            handleRightDrawer(true);
        } else {
            let signUpTrackingKey = validateField(headerSignUpTrackingKey, "object", "mobile")
                ? headerSignUpTrackingKey.mobile
                : "";
            this.loadSignUpLogin(signUpTrackingKey, "signUp");
        }
    };

    renderNav = () => {
        const {isHamburgerOpen, navHoverActiveIndex, navClickActiveIndex} = this.state;
        const {isMobile, gnbData} = this.props;
        if (
            gnbData &&
            (!isMobile || this.scrollStarted || this.hamburgerLoadCalled || isHamburgerOpen)
        ) {
            return (
                <OutsideAlerter
                    isMobile={isMobile}
                    isActive={isHamburgerOpen}
                    componentHandler={() => this.closeHamburger()}
                >
                    <NavItem
                        navMenuHoverEnter={this.navMenuHoverEnter}
                        navMenuHoverLeave={this.navMenuHoverLeave}
                        navHoverActiveIndex={navHoverActiveIndex}
                        handleHamburgerMainSection={this.handleHamburgerMainSection}
                        navClickActiveIndex={navClickActiveIndex}
                        gnbData={gnbData.data}
                        closeHamburger={this.closeHamburger}
                        openHamburger={this.openHamburger}
                        isHamburgerOpen={isHamburgerOpen}
                        // isMobile={isMobile}
                        navMenuClick={this.navMenuClick}
                    />
                </OutsideAlerter>
            );
        }
    };

    onMenuIconClick = () => {
        this.hamburgerLoadCalled = true;
        this.openHamburger();
    };

    renderMenuIconMobile = () => {
        const {isHamburgerOpen} = this.state;
        if (!this.hamburgerLoadCalled && !this.scrollStarted && !isHamburgerOpen) {
            return <MenuAnchor onClick={this.onMenuIconClick}>MENU</MenuAnchor>;
        }
    };

    backTickClickHandle = () => {
        if (this.props.aversionLayerHandler) {
            this.setState({showAversionLayer: true});
            this.aversionLayerURL = null;
        } else {
            const {referrerURL, isReferrerPWA, history} = this.props;
            if (referrerURL) {
                if (isReferrerPWA) {
                    history.push(referrerURL);
                } else {
                    window.location.href = referrerURL;
                }
                return;
            }
            window.location.href = config.BEACON_SHIKSHA_HOME;
        }
    };

    logoClickHandler = () => {
        if (this.props.aversionLayerHandler) {
            this.setState({showAversionLayer: true});
            this.aversionLayerURL = config.SHIKSHA_STUDYABROAD_HOME;
        } else if (this.props.enableSAHeaderLogoNavigation === true) {
            window.location.href = config.SHIKSHA_STUDYABROAD_HOME;
        }
    };

    closeAversionLayerHandler = () => {
        this.setState({showAversionLayer: false});
        if (this.aversionLayerURL) {
            this.aversionLayerURL = null;
            window.location.href = config.SHIKSHA_STUDYABROAD_HOME;
        } else {
            const {referrerURL, isReferrerPWA, history} = this.props;
            if (referrerURL) {
                if (isReferrerPWA) {
                    history.push(referrerURL);
                } else {
                    window.location.href = referrerURL;
                }
                return;
            }
            window.location.href = config.SHIKSHA_STUDYABROAD_HOME;
        }
    };

    extend(a, b) {
        for (var key in b) {
            /*eslint-disable */
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
            /*eslint-enable */
        }
        return a;
    }

    gnbTunneling(submenu, callbackObj) {
        console.log("header tunneling");
        var activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = this.extend(
                {
                    rowSelector: ".g_lev2 > li",
                    submenuSelector: "*",
                    submenuDirection: "right",
                    tolerance: 75,
                    enter: function () {},
                    exit: function () {},
                    activate: function () {},
                    deactivate: function () {},
                    exitMenu: function () {},
                },
                callbackObj,
            );
        var MOUSE_LOCS_TRACKED = 3,
            DELAY = 300;
        var mousemoveDocument = function (e) {
            mouseLocs.push({x: e.pageX, y: e.pageY});
            if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                mouseLocs.shift();
            }
        };
        var mouseleaveMenu = function (event) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            if (options.exitMenu(event.target)) {
                if (activeRow) {
                    options.deactivate(activeRow);
                }
                activeRow = null;
            }
        };
        var mouseenterRow = function (event) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            options.enter(event.target);
            possiblyActivate(event.target);
        };
        var mouseleaveRow = function (event) {
            options.exit(event.target);
        };
        var clickRow = function (event) {
            activate(event.currentTarget);
        };
        var activate = function (row) {
            if (row == activeRow) {
                return;
            }
            if (activeRow) {
                options.deactivate(activeRow);
            }
            options.activate(row);
            activeRow = row;
        };
        var activationDelay = function () {
            if (!activeRow) {
                return 0;
            }
            var boundRect = submenu.getBoundingClientRect();
            var offset_top = boundRect.y;
            var offset_left = boundRect.x;
            var upperLeft = {
                    x: offset_left,
                    y: offset_top - options.tolerance,
                },
                upperRight = {
                    x: offset_left + submenu.offsetWidth,
                    y: upperLeft.y,
                },
                lowerLeft = {
                    x: offset_left,
                    y: offset_top + submenu.offsetHeight + options.tolerance,
                },
                lowerRight = {
                    x: offset_left + submenu.offsetWidth,
                    y: lowerLeft.y,
                },
                loc = mouseLocs[mouseLocs.length - 1],
                prevLoc = mouseLocs[0];

            if (!loc) {
                return 0;
            }
            if (!prevLoc) {
                prevLoc = loc;
            }
            if (
                prevLoc.x < offset_left ||
                prevLoc.x > lowerRight.x ||
                prevLoc.y < offset_top ||
                prevLoc.y > lowerRight.y
            ) {
                return 0;
            }

            if (lastDelayLoc && loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                return 0;
            }

            var decreasingCorner = upperRight,
                increasingCorner = lowerRight;

            if (options.submenuDirection == "left") {
                decreasingCorner = lowerLeft;
                increasingCorner = upperLeft;
            } else if (options.submenuDirection == "below") {
                decreasingCorner = lowerRight;
                increasingCorner = lowerLeft;
            } else if (options.submenuDirection == "above") {
                decreasingCorner = upperLeft;
                increasingCorner = upperRight;
            }

            var decreasingSlope = slope(loc, decreasingCorner),
                increasingSlope = slope(loc, increasingCorner),
                prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                prevIncreasingSlope = slope(prevLoc, increasingCorner);

            if (decreasingSlope < prevDecreasingSlope && increasingSlope > prevIncreasingSlope) {
                lastDelayLoc = loc;
                return DELAY;
            }

            lastDelayLoc = null;
            return 0;
        };
        var possiblyActivate = function (row) {
            console.log("header possibly activate", row);
            var delay = activationDelay();
            if (delay) {
                timeoutId = setTimeout(function () {
                    possiblyActivate(row);
                }, delay);
            } else {
                activate(row);
            }
        };
        var slope = function (a, b) {
            return (b.y - a.y) / (b.x - a.x);
        };

        console.log("header events binding");
        submenu.addEventListener("mouseleave", mouseleaveMenu);
        submenu.querySelectorAll(options.rowSelector).forEach((currObj) => {
            console.log("header submenu binding 11", currObj);
            currObj.addEventListener("mouseenter", mouseenterRow);
            currObj.addEventListener("mouseleave", mouseleaveRow);
            currObj.addEventListener("click", clickRow);
        });
        document.addEventListener("mousemove", mousemoveDocument);
    }

    headerHtml = (headerClasses) => {
        const {
            pageName,
            userLoggedIn,
            showNewTagInHeader,
            hideGNBSearch,
            hideGNBLoginSignUp,
            hideGNBMenu,
            hideBackTick,
            isMobile,
        } = this.props;
        const {isLoading, showAversionLayer, headerReleased, isOpen} = this.state;
        // const pageStr = `${validateField(pageGroupName)?`${pageGroupName}_`:``}${pageName}`;
        const pageStr = pageName;
        let mobileLoggedInClass = "";
        if (userLoggedIn) mobileLoggedInClass = "mobileLoggedIn";
        const navRenderCondition = !hideGNBMenu && !isLoading;
        const backTickCondition = !hideBackTick && !isLoading;
        const utm_Webmedium = isMobile ? "mweb" : "dweb";
        const needCounselingUrl = `/apply?utm_source=GNB&utm_medium=${utm_Webmedium}&utm_campaign=NL`;
        return (
            <React.Fragment>
                {/*<HeaderContentLoader/>*/}
                <HeaderDiv
                    className={this.stickyWrapperClass}
                    onMouseOver={this.props.onMouseOverTop}
                    style={{
                        display: isMobile && headerReleased ? "none" : "",
                    }}
                >
                    <div id="header" className={headerClasses}>
                        {/* <VirtualWebinarDiv>
                            Explore Your Future: Join UK Virtual Fair!{" "}
                            <a href="https://bit.ly/3Bh81Zv" target="_blank" rel="noreferrer">
                                Register Now !!
                            </a>
                        </VirtualWebinarDiv> */}
                        <header className="abrd-hdr">
                            {navRenderCondition && this.renderMenuIconMobile()}
                            <div
                                className={
                                    this.props.enableSAHeaderLogoNavigation
                                        ? "logo"
                                        : "logo noCursor"
                                }
                                onClick={(event) => {
                                    this.props.enableSAHeaderLogoNavigation &&
                                        this.logoClickHandler();
                                    event.stopPropagation();
                                }}
                            >
                                {/* <a
                                    href={`${config.SHIKSHA_STUDYABROAD_HOME}`}
                                    alt="studyabroad.shiksha.com"
                                    title="logo-icn"
                                > */}
                                <i className="logo-icn" />
                                {/* </a> */}
                            </div>
                            <div
                                id="seachTextBox"
                                className="search-tabContent openSearchLyr"
                                onClick={() =>
                                    (window.location.href =
                                        config.SHIKSHA_STUDYABROAD_HOME + "/searchLayer")
                                }
                            >
                                Enter course, college, country or exam
                                <button type="button" name="button" className="SearchBtn">
                                    Search
                                </button>
                            </div>
                            {this.userSectionDesktopHandling()}
                            {!hideGNBLoginSignUp && (
                                <div className={["src-fldDiv", mobileLoggedInClass].join(" ")}>
                                    {pageStr != "applyHomePage" && pageStr != "TopperPage" && (
                                        //Mobile Header Contact Us
                                        <>
                                            <ContactUsMobileHeaderWrapper>
                                                <ContactUsMobileHeaderBox
                                                    onClick={this.toggleClass}
                                                >
                                                    {/* Contact Us */}
                                                    <i className="needCounsling-icon"></i>
                                                </ContactUsMobileHeaderBox>
                                                {isOpen && (
                                                    <OutsideAlerter
                                                        isMobile={this.props.isMobile}
                                                        // isActive={isHamburgerOpen}
                                                        componentHandler={() => this.toggleClass()}
                                                        overlayCheck={false}
                                                        isActive={isOpen}
                                                    >
                                                        <ContactUseDetailsMobBox
                                                            hideGNBSearch={hideGNBSearch}
                                                        >
                                                            <Anchor
                                                                linkHref={needCounselingUrl}
                                                                target={"_blank"}
                                                                isPWALink={false}
                                                                displayStyle={{
                                                                    mobile: {
                                                                        fontWeight: "400",
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                    },
                                                                    laptop: {
                                                                        fontWeight: "400",
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                    },
                                                                }}
                                                            >
                                                                <ContactUsHeadPhoneIcn />
                                                                Get Free Counseling
                                                            </Anchor>
                                                            <Anchor
                                                                linkHref={`tel:+91-8069474732`}
                                                                displayStyle={{
                                                                    mobile: {
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                    },
                                                                    laptop: {
                                                                        width: "100%",
                                                                        maxWidth: "100%",
                                                                    },
                                                                }}
                                                            >
                                                                <ContactUsCallIcon />
                                                                Call <strong>08069474732</strong>
                                                            </Anchor>
                                                        </ContactUseDetailsMobBox>
                                                    </OutsideAlerter>
                                                )}
                                            </ContactUsMobileHeaderWrapper>
                                        </>
                                        // <Anchor
                                        //     linkHref={needCounselingUrl}
                                        //     alt="Need Counseling"
                                        //     target={"_self"}
                                        //     title={"Need Counseling"}
                                        // >
                                        //     <i className="needCounsling-icon"></i>
                                        // </Anchor>
                                    )}
                                    {!hideGNBSearch && (
                                        <a
                                            id="searchLayerContainerLink"
                                            href={`${config.SHIKSHA_STUDYABROAD_HOME}/searchLayer`}
                                            className="search-hdr-icon"
                                            alt="search"
                                            aria-label="search"
                                        >
                                            <i className="src-icon" />
                                        </a>
                                    )}
                                    <a
                                        href="#"
                                        className=" user-hdr-icon"
                                        title="user-icn"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            this.userSectionMobileHandling();
                                        }}
                                    >
                                        <i className="user-icon" />
                                    </a>
                                    <i className={mobileLoggedInClass} />
                                    {userLoggedIn && showNewTagInHeader && (
                                        <DashboardTag newTag>NEW</DashboardTag>
                                    )}
                                </div>
                            )}
                        </header>
                        {isLoading && isMobile && <MenuLoader />}
                        {isLoading && !isMobile && <HeaderNavItemLoader />}
                        {navRenderCondition && this.renderNav()}
                        {backTickCondition && (
                            <BackTick
                                onClick={(event) => {
                                    this.backTickClickHandle();
                                    event.stopPropagation();
                                }}
                            />
                        )}
                        {showAversionLayer && (
                            <LossAversionLayer
                                showAversionLayer={showAversionLayer}
                                exitAversionLayer={this.closeAversionLayerHandler}
                                closeOnlyAversionLayer={() =>
                                    this.setState({showAversionLayer: false})
                                }
                            />
                        )}
                    </div>
                </HeaderDiv>
            </React.Fragment>
        );
    };

    closeGPDR() {
        this.setState({showInlineGDPRBanner: false, stopStickyGDPR: true});
    }

    render() {
        const {isHamburgerOpen, scrollStarted, headerCurrentlyStickyState} = this.state;
        const {isMobile, hideGNBSearch} = this.props;

        let headerClasses = ["main-header", "navheaderP"];
        headerClasses.push(this.state.headerClass);
        if (!hideGNBSearch && !isMobile) {
            headerClasses.push("innerPageHeader");
        }
        headerClasses = headerClasses.join(" ");
        let headerWrapper = null;
        let isEnableTransforms = true;
        if (this.props.isMobile) {
            this.stickyWrapperClass = "";
            isEnableTransforms = false;
        }
        if (this.state.navHoverActiveIndex !== false) {
            headerWrapper = "navHovered";
        }

        let isEnableSticky = "",
            stickyZIndex = "";
        if (isMobile) {
            isEnableSticky = this.props.isSticky && this.state.enableSticky && !isHamburgerOpen;
        } else {
            isEnableSticky = this.props.isSticky;
        }

        if (!isMobile || headerCurrentlyStickyState === true) {
            stickyZIndex = 9;
        }

        return (
            <div className={headerWrapper}>
                {this.state.showInlineGDPRBanner && <GDPR closeGDPR={this.closeGPDR} />}
                {scrollStarted && (
                    <>
                        {this.state.showStickyGDPRBanner && !this.state.stopStickyGDPR && (
                            <GDPR isSticky stickyPosition="top" closeGDPR={this.closeGPDR} />
                        )}
                        <Sticky
                            enabled={isEnableSticky}
                            bottomBoundary="#headerStickyEnd"
                            enableTransforms={isEnableTransforms}
                            onStateChange={this.handleStateChange}
                            innerZ={stickyZIndex}
                            outerWrapperHeight={isMobile ? 48 : undefined}
                        >
                            {this.headerHtml(headerClasses)}
                        </Sticky>
                    </>
                )}
                {!scrollStarted && (
                    <div
                        style={{
                            position: "relative",
                            zIndex: stickyZIndex,
                            top: 0,
                        }}
                    >
                        {this.headerHtml(headerClasses)}
                    </div>
                )}
            </div>
        );
    }
}

Header.propTypes = {
    history: PropTypes.object,
    gnbData: PropTypes.oneOfType([PropTypes.object]),
    isSticky: PropTypes.bool,
    hideGNBSearch: PropTypes.bool,
    onMouseOverTop: PropTypes.func,
    shortListData: PropTypes.object,
    userData: PropTypes.object,
    userLoggedIn: PropTypes.bool,
    isMobile: PropTypes.bool,
    setHeaderCurrentStickyStatus: PropTypes.func,
    setNavHoverStatus: PropTypes.func,
    handleRightDrawer: PropTypes.func,
    setHeaderExpandedShrinkStatus: PropTypes.func,
    headerSignUpTrackingKey: PropTypes.object,
    pageName: PropTypes.string,
    showNewTagInHeader: PropTypes.bool,
    setGNBHeight: PropTypes.func,
    isPageScrolling: PropTypes.bool,
    hideGNBLoginSignUp: PropTypes.bool,
    hideGNBMenu: PropTypes.bool,
    hideBackTick: PropTypes.bool,
    fetchGNB: PropTypes.func,
    referrerURL: PropTypes.string,
    isReferrerPWA: PropTypes.bool,
    aversionLayerHandler: PropTypes.bool,
    setAversionLayerHandler: PropTypes.func,
    setTrackingDataAction: PropTypes.func,
    enableSAHeaderLogoNavigation: PropTypes.bool,
    location: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        isPageScrolling: state.layout.isPageScrolling,
        referrerURL: state.layout.referrerURL,
        isReferrerPWA: state.layout.isReferrerPWA,
        pageName: validateField(state.layout, "object", "currentPageName")
            ? state.layout.currentPageName
            : "",
        headerSignUpTrackingKey: validateField(state.layout, "object", "currentSignUpTrackingKey")
            ? state.layout.currentSignUpTrackingKey
            : {},
        gnbData: state.layout.gnbItems,
        aversionLayerHandler: state.layout.aversionLayerHandler,
    };
};

export default connect(mapStateToProps, {
    setHeaderExpandedShrinkStatus,
    fetchGNB,
    setAversionLayerHandler,
    setTrackingDataAction,
})(Header);
